
{
  "fr": {
    "rules": {
      "length": "{value} caractères ou plus",
      "lowercase": "1 minuscule ou plus",
      "uppercase": "1 majuscule ou plus",
      "symbol": "1 caractère spécial ou plus",
      "number": "1 chiffre ou plus"
    }
  }
}
